import React, { useEffect, Fragment } from 'react';
import {
    changeDepartment1All,
    changeDepartment2All,
    changeNameAll,
    changePhoneAll,
    changeFaxAll,
    changeCellAll,
    changeEmailAll,
    changeAddressAll,
    changeAddress2All,
    changeWebsiteAll,
    changeSuiteRoomAll,
    changeLetterheadPersonsAll,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP10T10 = React.memo((props) => {
    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeCellAll(props.cell);
    }, [props.cell]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeWebsiteAll(props.website);
    }, [props.website]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    useEffect(() => {
        changeLetterheadPersonsAll(props.letterheadPersons);
    }, [props.letterheadPersons]);

    const handleSetPersonName = (index, event) => {
        props.setLetterheadPersonName(index, event.target.value)
    };

    const handleSetTitle = (personIndex, titleIndex, event) => {
        props.setLetterheadPersonTitle(personIndex, titleIndex, event.target.value)
    };

    const renderPersonTitles = (person, personIndex) => {
        return person.titles.map((title, index) => {
            if (props.letterheadPersons.length > 1 && index > 0) {
                return null;
            }

            return (
                <div className="variable">
                    <div className="label">Title Line {index + 1}:</div>
                    <input
                        type="text"
                        value={title}
                        placeholder="Title"
                        onChange={handleSetTitle.bind(this, personIndex, index)}
                    />
                </div>
            );
        });
    };

    const addPersonTitle = (index) => {
        props.addLetterheadPersonTitle(index);
    };

    const removePersonTitle = (index) => {
        props.removeLetterheadPersonTitle(index);
    };

    const renderPersons = () => {
        return props.letterheadPersons.map((person, index) => {
            let addTitleButton = <div className="add-button" onClick={addPersonTitle.bind(this, index)}><i class="fas fa-plus" /> Add Title</div>;
            let removeTitleButton = <div className="remove-button" onClick={removePersonTitle.bind(this, index)}><i class="fas fa-trash" /> Remove Title</div>;
            if ((props.letterheadPersons.length > 1 && person.titles.length >= 1) || person.titles.length >= 6) {
                addTitleButton = <div></div>;
            }
            if (person.titles.length <= 0) {
                removeTitleButton = null;
            }

            return (
                <Fragment>
                    <div className="person-title">Person {index + 1}:</div>
                    <div className="variable">
                        <div className="label">Person Name:</div>
                        <input
                            type="text"
                            placeholder="Name and Credentials"
                            value={person.name}
                            onChange={handleSetPersonName.bind(this, index)}
                        />
                    </div>
                    {renderPersonTitles(person, index)}
                    <div className="buttons-container">
                        {addTitleButton}
                        {removeTitleButton}
                    </div>
                    <hr />
                </Fragment>
            );
        });
    }

    let addPersonButton = <div className="add-person-button" onClick={props.addLetterheadPerson}><i class="fas fa-plus" /> Add Person</div>;
    let removePersonButton = <div className="remove-person-button" onClick={props.removeLetterheadPerson}><i class="fas fa-trash" /> Remove Person</div>;
    if (props.letterheadPersons.length >= 10) {
        addPersonButton = <div></div>;
    }
    if (props.letterheadPersons.length <= 0) {
        removePersonButton = null;
    }

    return (
        <form action="">
            <hr />
            <TextField
                limit="40"
                showCount
                label="Office Line 1"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Office/Department/Center Line 1"
            />
            <TextField
                limit="40"
                showCount
                label="Office Line 2"
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Office/Department/Center Line 2"
            />
            <hr />
            <Fragment>
                {renderPersons()}
                <div className="buttons-container">
                    {addPersonButton}
                    {removePersonButton}
                </div>
                <hr />
            </Fragment>
            <TextField
                isPhone
                phoneFormat={3}
                label="Main Number"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Cell"
                value={props.cell}
                setFunction={props.setCell}
                placeholder="Cell number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <TextField
                label="Email"
                value={props.email}
                setFunction={props.setEmail}
                placeholder="Email address"
            />
            <TextField
                label="Address 1"
                value={props.address}
                setFunction={props.setAddress}
                placeholder="Address Line 1"
            />
            <TextField
                label="Address 2"
                value={props.address2}
                setFunction={props.setAddress2}
                placeholder="Address Line 2"
            />
            <TextField
                label="Website"
                value={props.website}
                setFunction={props.setWebsite}
                placeholder="Web address"
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth Houston | UTHealth Behavioral Sciences Letterhead</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables one side</li>
                        <li>Size 8.5" wide x 11" tall</li>
                        <li>Color</li>
                        <li>70# Cougar Opaque</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP10T10;
